<script setup lang="ts">
import EmptyLayout from './EmptyLayout.vue'
import MainLayout from './MainLayout.vue'
import AuthLayout from './AuthLayout.vue'

import { markRaw, watch, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const layout = ref()

watch(
  () => route.meta?.layout as string | undefined,
  async (metaLayout) => {
    try {
      switch (metaLayout) {
        case 'AuthLayout':
          layout.value = markRaw(AuthLayout)
          break;
        case 'MainLayout':
          layout.value = markRaw(MainLayout)
          break;
        default:
          layout.value = markRaw(EmptyLayout)
          break;
      }
    } catch (e) {
      layout.value = markRaw(EmptyLayout)
    }
  },
  { immediate: true }
)
</script>

<template>
  <component :is="layout">
    <router-view v-slot="{ Component, route }">
      <transition>
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
  </component>
</template>